import axios from "axios";

export const fetchPictogram = async (pictogramId, params) => {
  try {
    const { data } = await axios.get(
      "/api/v2/pictogram/" + pictogramId,
      { params: params }
    );

    if (data && data.success) {
      return data.pictogram;
    }
    // throw new Error("No se pudo obtener la lista de pictogramas.");
    return null;
  } catch (e) {
    let error = null;

    if (axios.isAxiosError(e)) {
      // console.error("Error de red al cargar configuración del proyecto", e.message);
      error = new Error("Fallo en la solicitud HTTP para obtener el pictograma.");
    } else {
      console.error("Error inesperado al cargar pictogram", e);
      error = new Error("No se pudo cargar la pictogram.");
    }

    error.original = e;
    throw e;
  }

}

export const fetchPictogramLayers = async (pictogramId, params) => {
  return axios.get("/api/v2/pictogram/" + pictogramId + "/layers", { params: params });
}

export function getPictogramDesign(pictogramId) {
  return axios.get('/api/v2/pictogram/' + pictogramId + '/design');
}
